import React, { useState, useEffect } from "react";
import "./AssessmentGuruPage.css";
import { useAuthContext } from "../Auth/AuthContext";
import { Sparkles, Code, Calendar, ChevronLeft, Database } from "lucide-react";
import { useNavigate } from "react-router-dom";
import CreateAssessmentModal from "./CreateAssessmentModal";
import SessionDetailsPage from "./SessionDetailsPage";
import config from "../../config";

const AssessmentGuruPage = () => {
  const { userObjId ,walletData,fetchWallet} = useAuthContext();
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPath, setSelectedPath] = useState(null); // Track selected path
  const [viewMode, setViewMode] = useState("paths"); // 'paths' or 'sessions'

  const [assessmentPaths, setAssessmentPaths] = useState([]);
  const [sessionData, setSessionData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSessionLoading, setIsSessionLoading] = useState(false);
  const [error, setError] = useState("");


  // const [walletData, setWalletData] = useState(null);

useEffect(() => {
  if (userObjId) {
    fetchAssessmentPaths();
    // fetchWallet();
  }
}, [userObjId]);

// const fetchWallet = async () => {
//   try {
//     const response = await fetch(`${config.restAPI}/credits/get-user-wallet/`, {
//       method: 'POST',
//       credentials: 'include',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ user_obj_id: userObjId }),
//     });
//     if (!response.ok) throw new Error('Failed to fetch wallet');
//     const data = await response.json();
//     console.log(data)
//     setWalletData(data);
//   } catch (error) {
//     console.error('Error fetching wallet:', error);
//   }
// };

const totalSessions = walletData?.wallet?.prepassessment ?? 0;
// const usedSessions = assessmentPaths.length;
// const remainingSessions = Math.max(0, totalSessions - usedSessions);

  // const circumference = 2 * Math.PI * 54;
  // const usedDash =
  //   totalSessions > 0 ? (usedSessions / totalSessions) * circumference : 0;
  // const remainingDash =
  //   totalSessions > 0 ? (remainingSessions / totalSessions) * circumference : 0;

  // Fetch Assessment Paths on component mount
  // useEffect(() => {
  //   if (userObjId) {
  //     fetchAssessmentPaths();
  //   }
  // }, [userObjId]);

  const fetchAssessmentPaths = async () => {
    setIsLoading(true);
    setError("");

    try {
      const response = await fetch(
        `${config.restAPI}/assessments/getAssessmentPaths/?user_obj_id=${userObjId}`,
        {
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch assessment paths");
      }

      const data = await response.json();
      setAssessmentPaths(data.assessment_paths || []);
    } catch (error) {
      console.error("Error fetching assessment paths:", error);
      setError("Failed to load assessments. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSessionData = async (assessmentPathId) => {
    setIsSessionLoading(true);
    setError("");

    try {
      const response = await fetch(
        `${config.restAPI}/assessments/getAssessmentSessions/?assessment_path_id=${assessmentPathId}&user_obj_id=${userObjId}`,
        {
          credentials: "include",
          headers: { "Content-Type": "application/json" },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch session data");
      }

      const data = await response.json();
      setSessionData(data);
    } catch (error) {
      console.error("Error fetching session data:", error);
      setError("Failed to load session details. Please try again.");
      setSessionData(null);
    } finally {
      setIsSessionLoading(false);
    }
  };

  const handleSubscribeClick = () => {
    navigate("/pricing", { state: { activeTabName: "Assessment" } });
  };

  const handleNewSessionClick = () => {
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    // Refresh paths after creating new assessment
    fetchAssessmentPaths();
    fetchWallet();
  };

  const handlePathClick = (path) => {
    setSelectedPath(path);
    setViewMode("sessions");
    fetchSessionData(path.assessment_path_id);
  };

  const handleBackToPaths = () => {
    setSelectedPath(null);
    setSessionData(null);
    setViewMode("paths");
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };

  const getPathData = (path, inputType) => {
    // Normalize both the search term and the data's input_type by replacing underscores with spaces
    const normalizedInputType = inputType.replace(/_/g, " ").toLowerCase();
    const data = path.assessment_path_data?.find(
      (d) => d.input_type.toLowerCase() === normalizedInputType
    );
    // console.log(data);
    return data?.input_content || "";
  };

  const getStatusBadgeClass = (status) => {
    switch (status?.toLowerCase()) {
      case "completed":
        return "status-completed";
      case "incomplete left":
          return "status-incomplete";
      case "in_progress":
      case "pending":
      default:
        return "status-pending";
    }
  };

  const getStatusLabel = (status) => {
    switch (status?.toLowerCase()) {
      case "completed":
        return "COMPLETED";
      case "incomplete left":
        return "INCOMPLETE";
      case "in_progress":
      case "pending":
      default:
        return "PENDING";
    }
  };

  // const renderNewAssessmentCard = () => {
  //   const hasSessions = totalSessions;
  //   return (
  //     <>
  //       {hasSessions && (
  //         <button
  //           className="create-assessment-button"
  //           onClick={hasSessions ? handleNewSessionClick : undefined}
  //           disabled={!hasSessions}
  //           style={!hasSessions ? { opacity: 0.5, cursor: 'not-allowed' } : {}}      
  //         >
  //           <i className="fas fa-plus"></i>
  //           Create New Assessment
  //         </button>
  //       // ) : (
  //       //   <button
  //       //     className="create-assessment-button"
  //       //     onClick={handleSubscribeClick}
  //       //   >
  //       //     <i className="fas fa-lock"></i>
  //       //     Subscribe for AssessmentBot
  //       //   </button>
  //       )}
  //     </>
  //   );
  // };

  const renderNewAssessmentCard = () => (
    <button
      className="create-assessment-button"
      onClick={totalSessions > 0 ? handleNewSessionClick : undefined}
      disabled={totalSessions === 0}
      title={totalSessions === 0 ? "You're out of credits" : ""}
      style={totalSessions === 0 ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
    >
      <i className="fas fa-plus"></i>
      Create New Assessment
    </button>
    
  );

  const renderPathCard = (path, index) => {
    const language = getPathData(path, "programming_language");
    const database = getPathData(path, "database_name");

    return (
      <div
        className="assessment-card"
        key={path.assessment_path_id}
        onClick={() => handlePathClick(path)}
      >
        <div className="assessment-left">
          <div className="assessment-card-header">
            <div className="assessment-info">
              <div className="assessment-title-row">
                <h3>
                {`${path.session_type} ${language || "-"}`.toUpperCase()}

                </h3>
                <span className="assessment-id-badge">
                  #{String(index + 1).padStart(2, "0")}
                </span>
              </div>
              <div className="assessment-card-details">
                {/* <span className="assessment-topic">
                  <Code size={14} />
                  {language?.toUpperCase() || "-"}
                </span> */}
                <span className="assessment-topic">
                  <Database size={14} />
                  {database?.toUpperCase() || "-"}
                </span>
                <span className="assessment-duration">
                  <Calendar size={14} />
                  {formatDate(path.created_at)}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="assessment-right">
          <div className="launch-view">
            <i className="fas fa-chevron-right view-icon"></i>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="assessment-guru-page">
        <div className="hero-section">
          <div className="hero-content">
            <div className="hero-left">
              <h1 className="hero-title">
                {viewMode === "paths"
                  ? "Your Personalized Prep Assessment Coach"
                  : selectedPath?.session_type.charAt(0).toUpperCase() +
                    selectedPath?.session_type.slice(1)}
              </h1>
              <div className="assessment-hero-description">
                {viewMode === "paths" ? (
                  <>
                    <span className="assessment-title">
                    Kickstart your personalized prep assessment session! 
                    </span>
                    <span className="assessment-subtitle">
                      Prepare for success with tailored prep assessment sessions! After each session, receive a detailed report with actionable insights. Prepare with PrepAssessmentBot to upskill yourself!
                    </span>
                  </>
                ) : (
                  <>
                    <span className="assessment-title">
                      {getPathData(
                        selectedPath,
                        "programming_language"
                      ).toUpperCase()}{" "}
                      •{" "}
                      {getPathData(selectedPath, "database_name").toUpperCase()}
                    </span>
                    <span className="assessment-subtitle">
                      View all sessions for this assessment path
                    </span>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="session-counter">
          <svg width="100" height="100" viewBox="0 0 130 130">
            <circle cx="60" cy="60" r="54" fill="none"
              stroke="rgba(190, 5, 250, 0.15)" strokeWidth="7" />
            <circle cx="60" cy="60" r="54" fill="none"
              stroke="#BE05FA" strokeWidth="8" />
            <text x="60" y="55" textAnchor="middle" dominantBaseline="middle"
              fill="var(--text-primary)" fontSize="18" fontWeight="bold">
              {totalSessions}
            </text>
            <text x="60" y="72" textAnchor="middle" dominantBaseline="middle"
              fill="var(--text-primary)" fontSize="15" fontWeight="bold">
              Session
            </text>
            <text x="60" y="86" textAnchor="middle" dominantBaseline="middle"
              fill="var(--text-primary)" fontSize="15" fontWeight="bold">
              Credits
            </text>
          </svg>
        </div>


        {/* Loading State */}
        {isLoading && (
          <div className="loading-box">
            <div className="spinner"></div>
            <p>Loading assessments...</p>
          </div>
        )}
        
        {/* No subscription */}
        {/* {!isLoading && totalSessions === 0 && (
          <div className="no-session-box">
            <div className="no-session-content">
              <Sparkles color="#BE05FA" />
              <h3>Unlock Your Potential</h3>
              <p>
                Test your knowledge with AI-powered assessments and get detailed
                performance insights.
              </p>
              <button
                className="no-session-button"
                onClick={handleSubscribeClick}
              >
                Subscribe for AssessmentBot
              </button>
            </div>
          </div>
        )} */}

        {!isLoading && assessmentPaths.length === 0 && totalSessions === 0 && (
          <div className="no-session-box">
            <div className="no-session-content">
              <Sparkles color="#BE05FA" />
              <h3>You're Out of Credits</h3>
              <p>
                You have no assessment credits. Please contact your
                administrator to get more credits.
              </p>
            </div>
          </div>
        )}

        {/* Has subscription but no paths yet */}
        {!isLoading && walletData && assessmentPaths.length === 0 && totalSessions > 0 && (
          <div className="no-session-box">
            <div className="no-session-content">
              <Sparkles color="#BE05FA" />
              <h3>No Assessments Yet</h3>
              <p>
                Start your first assessment to test your knowledge and track
                your progress.
              </p>
              <button
                className="no-session-button"
                onClick={handleNewSessionClick}
              >
                <i className="fas fa-plus"></i> Create New Assessment
              </button>
            </div>
          </div>
        )}
        

        {/* Paths View */}
        {!isLoading &&
           assessmentPaths.length > 0 &&
           viewMode === "paths" &&  (
            <>
              <div>{renderNewAssessmentCard()}</div>
              <div className="assessment-card-container">
                {assessmentPaths.map((path, index) =>
                  renderPathCard(path, index)
                )}
              </div>
            </>
          )}

        {/* Sessions View */}

        {viewMode === "sessions" && selectedPath && (
          <>
            <div className="sessions-header">
              <button className="back-to-paths-btn" onClick={handleBackToPaths}>
                <ChevronLeft size={20} />
                Back to Paths
              </button>
            </div>
            <div className="session-detail-container">
              {isSessionLoading ? (
                <div className="loading-box">
                  <div className="spinner"></div>
                  <p>Loading session details...</p>
                </div>
              ) : sessionData ? (
                <SessionDetailsPage
                  language={getPathData(selectedPath, "programming_language")}
                  sessionData={sessionData}
                  formatDate={formatDate}
                  getStatusBadgeClass={getStatusBadgeClass}
                  getStatusLabel={getStatusLabel}
                  path={selectedPath}
                />
              ) : (
                <div className="no-session-box">
                  <div className="no-session-content">
                    <Sparkles color="#BE05FA" />
                    <h3>No Sessions Yet</h3>
                    <p>No sessions found for this assessment path.</p>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
      <CreateAssessmentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        refreshPaths={() => {
          fetchAssessmentPaths();
          fetchWallet();
        }}
      />
    </>
  );
};

export default AssessmentGuruPage;